import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'
import { createIcon } from '../../create-icon'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgSpeakerOff = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.23852 1.12296C8.4192 1.21331 8.53333 1.39798 8.53333 1.59998V14.4C8.53333 14.602 8.4192 14.7867 8.23852 14.877C8.05782 14.9673 7.84161 14.9478 7.68 14.8267L3.55555 11.7333H1.6C0.716345 11.7333 0 11.0169 0 10.1333V5.86665C0 4.983 0.716345 4.26665 1.6 4.26665H3.55555L7.68 1.17332C7.84161 1.05211 8.05782 1.03262 8.23852 1.12296ZM7.46667 2.66665L4.05333 5.22665C3.96101 5.29589 3.84874 5.33332 3.73333 5.33332H1.6C1.30545 5.33332 1.06667 5.5721 1.06667 5.86665V10.1333C1.06667 10.4279 1.30545 10.6667 1.6 10.6667H3.73333C3.84874 10.6667 3.96101 10.7041 4.05333 10.7733L7.46667 13.3333V2.66665ZM15.8438 5.48953C16.0521 5.69781 16.0521 6.03549 15.8438 6.24377L14.0876 7.99998L15.8438 9.7562C16.0521 9.96447 16.0521 10.3022 15.8438 10.5104C15.6355 10.7187 15.2978 10.7187 15.0895 10.5104L13.3333 8.75424L11.5772 10.5104C11.3689 10.7187 11.0311 10.7187 10.8228 10.5104C10.6146 10.3022 10.6146 9.96447 10.8228 9.7562L12.5791 7.99998L10.8228 6.24377C10.6146 6.03549 10.6146 5.69781 10.8228 5.48953C11.0311 5.28124 11.3689 5.28124 11.5772 5.48953L13.3333 7.24573L15.0895 5.48953C15.2978 5.28124 15.6355 5.28124 15.8438 5.48953Z"
    />
  </svg>
)
const ForwardRef = forwardRef(SvgSpeakerOff)
const IconSvgSpeakerOff = createIcon(ForwardRef, 'SvgSpeakerOff')
export default IconSvgSpeakerOff
